import { create } from "axios";
import { onReject, onRequest, onResolve } from "./interceptors";
import { getTenantBaseConfig } from "../../domainMapping/index";

/**
 * 因不同服务返回数据格式不一致，所以创建了 2 个 Axios 实例，以便使用不同的拦截器
 */

/**
 * 用于请求 OAuth 接口
 * 因为咱不知道 OAuth 返回数据的格式，所以拦截器目前都是空拦截器
 */

const { authUrl, apiUrl } = getTenantBaseConfig();
export const oauth = create({
  baseURL: authUrl,
  timeout: 10000,
});

oauth.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    config.headers["Pragma"] = "no-cache";
    config.headers["Accept"] = "application/json";
    return config;
  },
  (error) => {
    // Do something with request error
    console.log("request error", error);
    return Promise.reject(error);
  }
);
oauth.interceptors.response.use(
  (response) => {
    // Do something with request error
    console.log("request response", response);
    return response;
  },
  (error) => {
    // Do something with request error
    console.log("request error", error);
    return Promise.reject(error);
  }
);

/**
 * 新版 API 使用的 Axios 实例，将根据新接口返回数据类型进行拦截
 */
const common = create({
  baseURL: apiUrl,
  timeout: 10000,
});

common.interceptors.request.use(onRequest, (error) => {
  // Do something with request error
  console.log("request error", error);
  return Promise.reject(error);
});
common.interceptors.response.use(onResolve.bind(null, common), onReject);

export default common;
